<template>
    <div class="h2-wrapper">
        <h2 class="hh2" @click="toggleContent ">
            <slot></slot>
            <span v-if="hasContent" class="toggle-btn">
                {{ isHidden ? '+' : '-' }}
            </span>
        </h2>
        <div v-if="hasContent" class="content" :class="{ hidden: isHidden }">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        hide: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isHidden: true
        }
    },
    created() {
        this.isHidden = this.hasContent ? true : false;
        if (this.hide !== undefined) {
            this.isHidden = this.hide;
        }
    },
    computed: {
        hasContent() {
            return !!this.$slots.content;
        }
    },
    methods: {
       toggleContent() {
            if(!!this.$slots.content === false) return;
            console.log('toggleContent');
            this.isHidden = !this.isHidden
        }
    }
}
</script>

<style lang="scss" scoped>
.h2-wrapper {
    margin: 20px 0;
}
.hh2 {
    background: #f9f9f9; /* 浅灰背景，更柔和 */
    padding: 10px;
    font-size: 26px;
    font-weight: 700;
    color: #222; /* 深灰文字，更清晰 */
    margin: 40px 0 20px;
    padding-left: 10px;
    border-left: 5px solid #25b864; /* 左边强调线 */
    line-height: 1.4;
    letter-spacing: 0.3px;
    cursor: default;
    transition: all 0.25s ease;
}

.hh2:hover {
    color: #25b864;
    border-left-color: #1fa256;
    transform: translateX(3px);
}

@media (max-width: 768px) {
    .hh2 {
        font-size: 22px;
        margin: 30px 0 15px;
        padding-left: 8px;
        border-left-width: 4px;
    }
}


</style>